import type { ICognitoStorage } from 'amazon-cognito-identity-js';

/* eslint-disable class-methods-use-this */
class LocalStorage implements ICognitoStorage {
  private static instance: LocalStorage | null = null;

  public static getInstance(): LocalStorage {
    LocalStorage.instance ??= new LocalStorage();

    return LocalStorage.instance;
  }

  setItem(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    const item = window.localStorage.getItem(key);
    return item;
  }

  removeItem(key: string): void {
    window.localStorage.removeItem(key);
  }

  clear(): void {
    window.localStorage.clear();
  }
}

export default LocalStorage;
